var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tiktok"},[_c('div',{ref:"embedContainer"}),(_vm.loadScriptSrc)?_c('load-script',{attrs:{"src":_vm.loadScriptSrc}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }